
// import './Home.scss';
// import Details from '../components/HoroscopeDetails/Details';
// import Service from '../components/ServiceDetails/Service';
// import Other from '../components/OtherDetails/Other';
// import Feedback from '../components/Feedback/Feedback';
// import Contact from '../components/Contact/Contact';
// import InnerNav from '../components/InnerNav/InnerNav';
// import Footer from '../components/Footer/Footer';
// import logo from '../assets/logo.png'
// import { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';


// const Home = () => {


//   const location = useLocation();

//   useEffect(() => {
//     const hash = location.hash;
//     if (hash) {
//       const element = document.querySelector(hash);
//       if (element) {
//         // Optional smooth scroll
//         element.scrollIntoView({ behavior: 'smooth' });
//       }
//     }
//   }, [location]);



//   return (
//     <>
//       {/* Actual Home Content */}
//       <div className="home" id="home">
//         <InnerNav />
      
//         <main className="home-main">
//           <div className="home-header">
//             <div className="intro">
//           <h1>Your Path Is Illuminated By<br />
//             Road-Map Of Stars.....</h1>
//           <p>The Stars In the night sky act as a celestial gps - providing<br />
//             navigational guidance and astrological insights. discover<br />
//             what the cosmos has in store for you today</p>
            
//           <button className="button">
//             <a href="#contact">
//             Book An Appointment
//              </a>
//             </button>
         
//             </div>
//           <div className="logo">
//             <img src={logo} alt="logo" />
//           </div>
//           </div>

//         <Details />
//         <Service />
//         <Other />
//         <Feedback />
//         <Contact />
        
//         </main>
//         <Footer />
//       </div>

//     </>
//   );
// };

// export default Home;

















import './Home.scss';
import Details from '../components/HoroscopeDetails/Details';
import Service from '../components/ServiceDetails/Service';
import Other from '../components/OtherDetails/Other';
import Feedback from '../components/Feedback/Feedback';
import Contact from '../components/Contact/Contact';
import InnerNav from '../components/InnerNav/InnerNav';
import Footer from '../components/Footer/Footer';
import logo from '../assets/logo.png';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    
    <motion.div
      className="home"
      id="home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
    <div className="border">
    
      <InnerNav />
      <main className="home-main">
        <div className="home-header">
          <div className="intro">
            <h1>
              Your Path Is Illuminated By<br />
              Road-Map Of Stars.....
            </h1>
            <p>
              The Stars In the night sky act as a celestial gps - providing<br />
              navigational guidance and astrological insights. discover<br />
              what the cosmos has in store for you today
            </p>
            <button className="button">
              <a href="#contact">Book An Appointment</a>
            </button>
          </div>

          <div className="logo">
            <motion.img
              src={logo}
              alt="logo"
              animate={{
                scale: [1, 1.05, 1],
              }}
              transition={{
                repeat: Infinity,
                duration: 4,
                ease: 'easeInOut',
              }}
            />
          </div>
        </div>

        <Details />
        <Service />
        <Other />
        {/* <Feedback /> */}
        <Contact />
      </main>

      <Footer />
      </div>
    </motion.div>
  );
};

export default Home;
